import React from 'react'
import PropTypes from 'prop-types'
import {articleCardDefault} from './utils'
import {CustomGrid} from './customGrid'
import {DynamicGrid} from './dynamicGrid'

export const CustomArticleGrid = (props) => {
    const {customGrid} = props

    return customGrid ? (
        <CustomGrid {...props} data-testid="articleGrid-CustomGrid" />
    ) : (
        <DynamicGrid {...props} data-testid="articleGrid-DynamicGrid" />
    )
}

CustomArticleGrid.propTypes = {
    attributes: PropTypes.object,
    builderBlock: PropTypes.object,
    articleCards: PropTypes.arrayOf(PropTypes.object),
    customGrid: PropTypes.bool,
    itemsToShowPerLoad: PropTypes.number
}

export const ArticleGridDefinition = {
    component: CustomArticleGrid,
    name: 'ArticleGrid',
    canHavechildren: true,
    childRequirements: {
        message: "Children of 'ArticleGrid' must be 'ArticleCard'",
        query: {
            'component.name': {$in: ['ArticleCard']}
        }
    },
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    noWrap: true,
    inputs: [
        {name: 'itemsToShowPerLoad', type: 'number', defaultValue: 10},
        {name: 'customGrid', type: 'boolean', defaultValue: false},
        {
            name: 'articleCards',
            type: 'list',
            subFields: [
                {
                    name: 'content',
                    type: 'uiBlocks',
                    defaultValue: articleCardDefault
                }
            ],
            showIf: `options.get('customGrid') === true`,
            defaultValue: [articleCardDefault]
        }
    ]
}
